import React from 'react';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import HowItWorks from '../components/HowItWorks';
import CompetitiveAdvantages from '../components/CompetitiveAdvantages';
import CTA from '../components/CTA';

const Home = () => {
  return (
    <div className="home-page">
      <Hero />
      <Stats />
      <HowItWorks />
      <CompetitiveAdvantages />
      <CTA />
    </div>
  );
};

export default Home;


